// extracted by mini-css-extract-plugin
export default {"console":"Console_console__LhZHn","closeIcon":"Console_closeIcon__yxP4b","consoleTitle":"Console_consoleTitle__d7ERQ","consoleContent":"Console_consoleContent__DwAiI"};